import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectProfile } from '../store/authSlice';

const getUserAccessList = (profile) => {
  const roles = profile?.data?.role[0];
  return roles?.access || [];
};

export const useAccess = (featureName, requiredAccess) => {
  const profile = useSelector(selectProfile);

  const hasAccess = useMemo(() => {
    const accessList = getUserAccessList(profile);
    const access = accessList.find(
      (item) =>
        String(item?.featureName || '').toLowerCase() === String(featureName || '').toLowerCase()
    );

    switch (requiredAccess) {
      case 'V':
        return access?.view === 'Y';
      case 'C':
        return access?.create === 'Y';
      default:
        return false;
    }
  }, [profile, featureName, requiredAccess]);

  return hasAccess;
};
